import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-16 pb-24 lg:pt-20 lg:pb-32 overflow-hidden" data-id="element-83" data-mp="ej4o9zmlcfgi">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative flex flex-col items-center text-center" data-id="element-84" data-mp="9lv0spiridvb">
        {/* Feature Photo */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6
      }} className="relative w-full max-w-md mb-16" data-id="element-85" data-mp="4jm5hmif2zq1">
          <div className="relative z-10 border-4 border-foodMaroon shadow-[12px_12px_0px_0px_#9C3A28] bg-foodMaroon aspect-square overflow-hidden" data-id="element-86" data-mp="sd4d16jx3gql">
            <video src="https://cdn.magicpatterns.com/uploads/wuA7x4EgU29bH4qchvZZZk/download (3).mp4" autoPlay loop muted playsInline className="w-full h-full object-cover" data-id="element-87" data-mp="3d2l95b1th306" />
          </div>

          {/* Decorative Elements */}
          <motion.div animate={{
          scale: [1, 1.08, 1]
        }} transition={{
          duration: 1.6,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="absolute -top-8 -right-8 z-20 w-36 h-36 bg-foodGold rounded-full flex items-center justify-center border-4 border-foodMaroon shadow-[4px_4px_0px_0px_#34302A]" data-id="element-88" data-mp="3o6u7fbahgtdg">
            <div className="text-center px-2" data-id="element-89" data-mp="35akifsy1mieo">
              <span className="block font-display font-bold text-foodMaroon text-lg leading-tight tracking-tight" data-id="element-90" data-mp="2qkwj2x9f9ttl">
                SEPTEMBER
              </span>
              <span className="block font-display font-bold text-foodMaroon text-xl leading-tight" data-id="element-91" data-mp="2hjf6hov84a9n">
                POP UP
              </span>
            </div>
          </motion.div>

          <div className="absolute -bottom-6 -left-6 z-0 w-full h-full bg-foodTomato border-4 border-foodMaroon" data-id="element-92" data-mp="2lml8gkbazfab" />
        </motion.div>

        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="flex flex-col items-center" data-id="element-93" data-mp="n9qid8z0cs7f">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-foodGold text-foodMaroon font-bold mb-6 border-2 border-foodMaroon shadow-[4px_4px_0px_0px_#34302A] rotate-[-2deg]" data-id="element-94" data-mp="1ayt8743sprd0">
            <Sparkles size={20} data-id="element-95" data-mp="110wohnwslo3a" />
            <span data-id="element-96" data-mp="x14npxdn4m8h">Community Food Hub</span>
          </div>
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold leading-[1.1] mb-6 uppercase max-w-4xl" data-id="element-97" data-mp="x0l2o7sp1hq8">
            Where Our Community{' '}
            <span className="text-foodOrange" data-id="element-98" data-mp="3hrlosum1wtes">Gathers</span>,{' '}
            <span className="whitespace-nowrap" data-id="element-99" data-mp="3htg9c7teujic">Cooks &amp; Celebrates.</span>
          </h1>
          <p className="text-lg sm:text-xl text-foodMaroon/80 mb-8 font-medium max-w-2xl" data-id="element-100" data-mp="1xb5mo58pibbw">
            Join us for vibrant monthly pop-ups, hands-on culinary workshops,
            and community events that bring our neighborhood together through
            food.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-101" data-mp="2b2ai0v51khgf">
            <a href="#popups" className="inline-flex justify-center items-center gap-2 bg-foodOrange text-white px-8 py-4 font-bold text-lg border-2 border-foodMaroon shadow-[4px_4px_0px_0px_#34302A] hover:translate-y-[2px] hover:translate-x-[2px] hover:shadow-[2px_2px_0px_0px_#34302A] transition-all" data-id="element-102" data-mp="2g0lqp2jlolx2">
              See This Month's Pop-Up
              <ArrowRight size={20} data-id="element-103" data-mp="umzgnr083w58" />
            </a>
            <a href="#workshops" className="inline-flex justify-center items-center gap-2 bg-transparent text-foodMaroon px-8 py-4 font-bold text-lg border-4 border-foodMaroon hover:bg-foodMaroon hover:text-foodCream transition-colors" data-id="element-104" data-mp="uoak1pprb1vt">
              Join a Workshop
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}